/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, CompanyID, isEmpty, isSingleSelect, isValidPrice, isMultiSelect, uploadFile, removeFile } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";

var module = "products";
var moduleName = "Vouchers";
var modulePath = "/clientpanel/catalog-products";
import { format } from "date-fns";
const defaultTerms =
  "<ol><li>Voucher is valid for retail store redemption.</li><li>The voucher will be valid till consumed.</li> <li>Once sold, vouchers are non-refundable and cannot be exchanged.</li><li>Voucher is not transferrable, cash redeemable and not replaceable.</li><li>Voucher is to be redeemed at only the participating outlets and presented to outlet staff before ordering.</li><li>Voucher is not to be used in conjunction with other promotions, discounts, offers, vouchers and privileges.</li><li>All vouchers can be used multiple times in full or in partial.</li><li>Brand reserves the right to amend the terms & conditions as necessary, without prior notice.</li><li>Please show this E-Voucher on your handheld devices upon payment. You need not print this E-Voucher for redemption.</li></ol>";
class Form extends Component {
  constructor(props) {
    super(props);
    const ProName = this.props.location.state?.title || "";
    const ProDescription = this.props.location.state?.description || "";
    this.state = {
      editID: this.props.params?.EditID || "",
      pageloading: false,
      clientdata: {
        productOutletID: [],
        productType: "",
        productCategoryID: "",
        productName: ProName,
        productAliasName: "",
        productSKU: "",
        productShortDescription: "",
        productLongDescription: ProDescription,
        productTermsandConditions: defaultTerms,
        productPrice: "",
        productStatus: [],
        productVoucherExpiryDays: "",
        productThumbnail: "",
        productLargeImage: "",
        action: "add",
      },
      btndisabled: false,
      loading: true,
      formpost: [],
      companyDetail: [],
      outletList: [],
      productTypeList: [
        {
          label: "Reward Voucher",
          value: "1",
        },
        {
          label: "Point Voucher",
          value: "5",
        },
      ],
      companyCatList: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.loadOutlet();
    /* this.loadproductTypeList(); */
    this.comapanyCatlist();

    if (this.state.editID !== "") {
      var params = {
        params: "company_id=" + CompanyID(),
        url: `${apiUrl}${module}/details/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost != nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          var productStatus = result.productStatus == "A" ? "Active" : "Inactive";
          var productStatus =
            result.productStatus !== "" && result.productStatus !== null
              ? {
                  label: productStatus,
                  value: result.productStatus,
                }
              : "";

          var productType = "";
          if (result.productType === 1) {
            productType = {
              label: "Reward Voucher",
              value: "1",
            };
          } else if (result.productType === 5) {
            productType = {
              label: "Point Voucher",
              value: "5",
            };
          }
          var clientupdatedata = {
            productOutletID: result.productOutletID.length > 0 ? result.productoutletList : [],
            productType: productType,
            productCategoryID: result.productCategoryDisplay.length > 0 ? result.productCategoryDisplay[0] : "",
            productName: result.productName,
            productAliasName: result.productAliasName,
            productSKU: result.productSKU,
            productShortDescription: result.productShortDescription !== null ? result.productShortDescription : "",
            productLongDescription: result.productLongDescription !== null ? result.productLongDescription : "",
            productTermsandConditions: result.productTermsandConditions !== null ? result.productTermsandConditions : "",
            productPrice: result.productPrice || "",
            productVoucherExpiryDays: result.productVoucherExpiryDays,
            productThumbnail: result.productThumbnail !== "" && result.productThumbnail !== null ? result.productThumbnail : "",
            productLargeImage: result.productLargeImage !== "" && result.productLargeImage !== null ? result.productLargeImage : "",
            productStatus: productStatus,
            action: "edit",
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid Product", "error");
        }
      });
    }
  }

  loadOutlet() {
    var urlShringTxt = apiUrl + "outlet/dropdown?company_id=" + CompanyID();
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ outletList: res.data.result });
        }
      })
      .catch();
  }

  comapanyCatlist() {
    var urlShringTxt = apiUrl + "company/categoryList?company_id=" + CompanyID();
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ companyCatList: res.data.result });
        }
      })
      .catch();
  }

  loadproductTypeList() {
    var urlShringTxt = apiUrl + module + "productType?company_id=" + CompanyID();
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ productTypeList: res.data.result });
      }
    });
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { clientdata: { [field]: { $set: value } } }), function () {
      if (field === "productOutletID") {
      }
    });
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;

    var productType = Object.keys(postData.productType).length > 0 ? postData.productType.value : "";
    var productOutletID = [];
    if (postData.productOutletID.length > 0) {
      postData.productOutletID.map((item) => {
        productOutletID.push(item.value);
        return "";
      });
    }
    const editorContent = $("#editorContent").val();
    const editorContent1 = $("#editorContent1").val();
    const editorContent2 = $("#editorContent2").val();
    var postObject = {
      productType: postData.productType?.value ? parseInt(postData.productType?.value) : 1,
      productName: postData.productName,
      productAliasName: postData.productAliasName,
      productSKU: postData.productSKU,
      productShortDescription: editorContent,
      productLongDescription: editorContent1,
      productTermsandConditions: editorContent2,
      productStatus: postData.productStatus?.value || "A",
      productPrice: postData.productPrice,
      productOutletID: productOutletID.length > 0 ? productOutletID.join(",") : "",
      productCategoryID: postData.productCategoryID?.value || "",
      productVoucherExpiryDays: postData.productVoucherExpiryDays,
      productThumbnail: postData.productThumbnail,
      productLargeImage: postData.productLargeImage,
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"catalog-products"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  sateValChange={this.sateValChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  outletList={this.state.outletList}
                  companyCatList={this.state.companyCatList}
                  productTypeList={this.state.productTypeList}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                          },
                          500,
                        );
                      }
                    }, 500);
                  }}
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { productOutletID, productType, productCategoryID, productName, productSKU, productPrice, productStatus } = props.fields;

  return {
    fields: ["productOutletID", "productType", "productCategoryID", "productName", "productSKU", "productPrice", "productStatus"],

    validations: {
      productOutletID: [[isMultiSelect, productOutletID]],
      productType: [[isSingleSelect, productType]],
      productCategoryID: [[isSingleSelect, productCategoryID]],
      productName: [[isEmpty, productName]],
      productSKU: [[isEmpty, productSKU]],
      productPrice: [
        [isEmpty, productPrice],
        [isValidPrice, productPrice],
      ],
      productStatus: [[isSingleSelect, productStatus]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  setContent(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeCheck(name, event) {
    var value = event.target.checked === true ? "1" : "0";
    this.props.onChange(name, value);
  }
  myFilter(elm) {
    return elm != null && elm !== false && elm !== "";
  }

  async uplaodFiles(imageType) {
    try {
      this.props.sateValChange("btndisabled", true);
      showLoader(`ImageDetails${imageType}`);
      showLoader(`ImageContainer${imageType}`);
      var imagefile = document.querySelector("#" + imageType);
      const file = imagefile.files[0];
      var fileDetail = await uploadFile(file, "products", "client", "epicpay");
      if (fileDetail.status === "ok") {
        this.props.onChange(imageType, fileDetail.url);
      }
      hideLoader(`ImageContainer${imageType}`);
      hideLoader(`ImageDetails${imageType}`);
      $("#" + imageType).val("");
      this.props.sateValChange("btndisabled", false);
    } catch (e) {
      hideLoader("ImageContainer");
      hideLoader("ImageDetails");
      $("#" + imageType).val("");
      this.props.sateValChange("btndisabled", false);
    }
  }
  async removeImage(fileNamme, imageType) {
    showLoader(`ImageDetails${imageType}`, "class");
    var fileDetail = await removeFile(fileNamme, "client", "epicpay");
    if (fileDetail.status === "ok") {
      hideLoader(`ImageDetails${imageType}`, "class");
      this.props.onChange(imageType, "");
    }
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgOutlet, errMsgProductType, errMsgCompanyCatId, errMsgProName, errMsgsku, errMsgStatus, errMsgProPrice;

    if ($validation.productOutletID.error.reason !== undefined) {
      errMsgOutlet = $validation.productOutletID.show && <span className="error">{$validation.productOutletID.error.reason}</span>;
    }
    if ($validation.productType.error.reason !== undefined) {
      errMsgProductType = $validation.productType.show && <span className="error">{$validation.productType.error.reason}</span>;
    }
    if ($validation.productCategoryID.error.reason !== undefined) {
      errMsgCompanyCatId = $validation.productCategoryID.show && <span className="error">{$validation.productCategoryID.error.reason}</span>;
    }
    if ($validation.productName.error.reason !== undefined) {
      errMsgProName = $validation.productName.show && <span className="error">{$validation.productName.error.reason}</span>;
    }
    if ($validation.productSKU.error.reason !== undefined) {
      errMsgsku = $validation.productSKU.show && <span className="error">{$validation.productSKU.error.reason}</span>;
    }
    if ($validation.productPrice.error.reason !== undefined) {
      errMsgProPrice = $validation.productPrice.show && <span className="error">{$validation.productPrice.error.reason}</span>;
    }
    if ($validation.productStatus.error.reason !== undefined) {
      errMsgStatus = $validation.productStatus.show && <span className="error">{$validation.productStatus.error.reason}</span>;
    }
    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="row g-3">
          <div className="accordion mt-3 accordion-header-primary" id="accordionStyle1">
            <div className="accordion-item active">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-3" aria-expanded="true">
                  General Info
                </button>
              </h2>
              <div id="accordionStyle1-3" className="accordion-collapse collapse show  mt-3" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className={errMsgOutlet !== "" && errMsgOutlet !== false && errMsgOutlet !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productOutletID}
                          onChange={this.handleSelectChange.bind(this, "productOutletID")}
                          placeholder={"Select Outlet"}
                          options={this.props.outletList}
                          isMulti
                          isClearable={true}
                        />
                        <label className="select-box-label">
                          Outlet<span className="error">*</span>
                        </label>
                        {errMsgOutlet}
                      </div>
                    </div>
                    <div className={errMsgProductType !== "" && errMsgProductType !== false && errMsgProductType !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productType}
                          onChange={this.handleSelectChange.bind(this, "productType")}
                          placeholder={"Select Product Type"}
                          options={this.props.productTypeList}
                          isClearable={true}
                        />
                        <label className="select-box-label">
                          Product Type<span className="error">*</span>
                        </label>
                        {errMsgProductType}
                      </div>
                    </div>

                    <div className={errMsgCompanyCatId !== "" && errMsgCompanyCatId !== false && errMsgCompanyCatId !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productCategoryID}
                          onChange={this.handleSelectChange.bind(this, "productCategoryID")}
                          placeholder={"Select Category"}
                          options={this.props.companyCatList}
                          isClearable={true}
                        />
                        <label className="select-box-label">
                          Category<span className="error">*</span>
                        </label>
                        {errMsgCompanyCatId}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={errMsgProName !== "" && errMsgProName !== false && errMsgProName !== undefined ? "form-control is-invalid" : "form-control"}
                          name="productName"
                          value={fields.productName}
                          {...$field("productName", (e) => onChange("productName", e.target.value))}
                        />
                        <label htmlFor="productName">
                          Voucher Name <span className="error">*</span>
                        </label>
                        {errMsgProName}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productAliasName"
                          value={fields.productAliasName}
                          {...$field("productAliasName", (e) => onChange("productAliasName", e.target.value))}
                        />
                        <label htmlFor="productAliasName">Alias Name</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={errMsgsku !== "" && errMsgsku !== false && errMsgsku !== undefined ? "form-control is-invalid" : "form-control"}
                          name="productSKU"
                          value={fields.productSKU}
                          {...$field("productSKU", (e) => onChange("productSKU", e.target.value))}
                        />
                        <label htmlFor="productSKU">
                          SKU <span className="error">*</span>
                        </label>
                        {errMsgsku}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productVoucherExpiryDays"
                          value={fields.productVoucherExpiryDays}
                          {...$field("productVoucherExpiryDays", (e) => onChange("productVoucherExpiryDays", e.target.value))}
                        />
                        <label htmlFor="productVoucherExpiryDays">Voucher Expiry Days</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={errMsgProPrice !== "" && errMsgProPrice !== false && errMsgProPrice !== undefined ? "form-control is-invalid" : "form-control"}
                          name="productPrice"
                          value={fields.productPrice}
                          {...$field("productPrice", (e) => onChange("productPrice", e.target.value))}
                        />
                        <label htmlFor="productPrice">
                          Redeem Point <span className="error">*</span>
                        </label>
                        {errMsgProPrice}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label>Short Description</label>
                      <Editor IDName={"editorContent"} data={fields.productShortDescription} />
                    </div>
                    <div className="col-md-12">
                      <label>Long Description</label>
                      <Editor IDName={"editorContent1"} data={fields.productLongDescription} />
                    </div>
                    <div className="col-md-12">
                      <label>Terms and Conditions</label>
                      <Editor IDName={"editorContent2"} data={fields.productTermsandConditions} />
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <div className="mb-3" id="ImageContainerproductThumbnail">
                          <label htmlFor="formFile" className="form-label">
                            Thumbnail Image
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            id="productThumbnail"
                            onChange={(event) => {
                              this.uplaodFiles("productThumbnail", event);
                              return false;
                            }}
                          />
                          For Recommendation Size : <b>280px X 160px</b>
                          <br />
                          For Crop Image :{" "}
                          <b>
                            <a href="https://imageresizer.com/crop-image" target="_blank">
                              click here
                            </a>
                          </b>
                        </div>
                      </div>
                      {fields.productThumbnail !== "" && (
                        <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                          <div className="dz-details" id="ImageDetailsproductThumbnail">
                            <div className="dz-thumbnail">
                              <img alt="" src={fields.productThumbnail} />
                            </div>
                          </div>
                          <a className="dz-remove" href={void 0} onClick={this.removeImage.bind(this, fields.productThumbnail, "productThumbnail")}>
                            Remove file
                          </a>
                        </div>
                      )}
                      
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <div className="mb-3" id="ImageContainerproductLargeImage">
                          <label htmlFor="formFile" className="form-label">
                            Thumbnail Image
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            id="productLargeImage"
                            onChange={(event) => {
                              this.uplaodFiles("productLargeImage", event);
                              return false;
                            }}
                          />
                          For Recommendation Size : <b>280px X 160px</b>
                          <br />
                          For Crop Image :{" "}
                          <b>
                            <a href="https://imageresizer.com/crop-image" target="_blank">
                              click here
                            </a>
                          </b>
                        </div>
                      </div>
                      {fields.productLargeImage !== "" && (
                        <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                          <div className="dz-details" id="ImageDetailsproductLargeImage">
                            <div className="dz-thumbnail">
                              <img alt="" src={fields.productLargeImage} />
                            </div>
                          </div>
                          <a className="dz-remove" href={void 0} onClick={this.removeImage.bind(this, fields.productLargeImage, "productLargeImage")}>
                            Remove file
                          </a>
                        </div>
                      )}
                      
                    </div>
                    

                    <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                      <br></br>
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productStatus}
                          onChange={this.handleSelectChange.bind(this, "productStatus")}
                          placeholder="Select Status"
                          options={[
                            { value: "A", label: "Active" },
                            { value: "I", label: "Inactive" },
                          ]}
                          isClearable={true}
                        />
                        <label className="select-box-label">
                          Status<span className="error">*</span>
                        </label>
                        {errMsgStatus}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-1 pb-4 pr-2 text-end" style={{ paddingRight: "20px" }}>
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
